import React from 'react';
import { Reveal } from './motion';

const ICONS = {
  strava: 'M9.5 3 3.8 14.2h3.4L9.5 9.5l2.3 4.7h3.4L9.5 3zm5.1 11.2-1.7 3.3-1.7-3.3H8.8l3.1 6.1 3.1-6.1h-2.4z',
  cloud: 'M7 18a4 4 0 0 1-.4-8A5.5 5.5 0 0 1 17.3 10 3.6 3.6 0 0 1 17 18H7z',
  wave: 'M3 8c2 0 2 2 4 2s2-2 4-2 2 2 4 2 2-2 4-2M3 14c2 0 2 2 4 2s2-2 4-2 2 2 4 2 2-2 4-2',
  phone: 'M8 3h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM11 18h2',
  table: 'M4 5h16v14H4zM4 10h16M10 10v9',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
};

const INTEGRATIONS = [
  {
    icon: 'strava',
    filled: true,
    name: 'Strava',
    body: 'Connect once and activities flow straight into the training log \u2014 with meters optionally attributed to the boat you reserved.',
  },
  {
    icon: 'cloud',
    name: 'Live weather',
    body: 'Air temperature, feels-like and wind for your club\u2019s location, on every session card.',
  },
  {
    icon: 'wave',
    name: 'USGS river gauge',
    body: 'Water temperature and discharge from the gauge you pick \u2014 Fairmount, or wherever you row.',
  },
  {
    icon: 'phone',
    name: 'iOS & Android',
    body: 'A companion app for athletes, with push notifications when a test piece or workout drops.',
  },
  {
    icon: 'table',
    name: 'CSV in and out',
    body: 'Bulk-import rosters, workouts and training plans. Export any report you build.',
  },
  {
    icon: 'mail',
    name: 'Email & invitations',
    body: 'Announcements and invite links, with opt-out preferences respected per member.',
  },
];

export default function IntegrationsBand() {
  return (
    <section className="relative overflow-hidden bg-slate-950 py-20 sm:py-28">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_60%_at_50%_0%,rgba(37,99,235,0.18),transparent_70%)]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-6xl safe-area-x sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-400">
            Connected
          </p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            It already talks to the things your club uses.
          </h2>
          <p className="mt-4 text-lg text-slate-400">
            No middleware, no spreadsheets in between. The data your program depends on shows up
            where the decision gets made.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {INTEGRATIONS.map((item, i) => (
            <Reveal key={item.name} delay={(i % 3) * 0.07} y={20}>
              <div className="h-full bg-slate-950 p-6 transition-colors hover:bg-slate-900">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-300">
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill={item.filled ? 'currentColor' : 'none'}
                    stroke={item.filled ? 'none' : 'currentColor'}
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d={ICONS[item.icon]} />
                  </svg>
                </div>
                <h3 className="mt-4 text-base font-semibold text-white">{item.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
